export const getFromLocalStorage = key => {
  if (typeof window !== "undefined") {
    let value = window.localStorage.getItem(key) || JSON.stringify(null);
    value = value === "undefined" ? JSON.stringify(null) : value;
    return JSON.parse(value);
  }
  return null;
};

export const setToLocalStorage = (key, value) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
};

export const removeFromLocalStorage = key => {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(key);
  }
};
